import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/purchaseNotifications';
const FIRST_DELAY_MS = 6000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 12000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timeoutId = window.setTimeout(() => {
      if (isVisible) {
        setIsVisible(false);
        setIndex(current => (current + 1) % purchaseNotifications.length);
      } else {
        setIsVisible(true);
      }
    }, isVisible ? VISIBLE_MS : index === 0 ? FIRST_DELAY_MS : HIDDEN_MS);
    return () => window.clearTimeout(timeoutId);
  }, [isVisible, index, isDismissed]);
  const current = purchaseNotifications[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)]" data-id="element-135" data-mp="tkl8805q728s">
      <AnimatePresence data-id="element-136" data-mp="os0jhd1offc4">
        {isVisible && !isDismissed && <motion.div key={`${current.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto relative flex w-[290px] items-start gap-3 rounded-card border border-card-border bg-white p-3 pr-8 shadow-lg" data-id="element-137" data-mp="jtqmqy0b06oe">
            <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-[#75B989]/15" data-id="element-138" data-mp="12muj4r4woxmp">
              <ShoppingBagIcon className="h-5 w-5 text-[#4E7A5A]" aria-hidden="true" data-id="element-139" data-mp="3nb8tt38959nr" />
            </span>

            <div className="min-w-0" data-id="element-140" data-mp="3j8u6o6xjvnqo">
              <p className="text-[14px] font-semibold leading-snug text-deep-blue" data-id="element-141" data-mp="3jbzwjoe06tng">
                {current.name} · {current.city}
              </p>
              <p className="mt-0.5 text-[13px] leading-snug text-ink/70" data-id="element-142" data-mp="3pokp1u7usk20">
                Compró el{' '}
                <span className="font-semibold text-ink/85" data-id="element-143" data-mp="3artnbeapiw98">{current.pack}</span>
              </p>
              <p className="mt-1 text-[11px] font-medium uppercase tracking-wide text-ink/45" data-id="element-144" data-mp="3fqelz9ab97vk">
                Hace {current.minutesAgo} minutos
              </p>
            </div>

            <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-ink/35 transition-colors hover:text-ink/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-145" data-mp="36r9tokpcearu">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-146" data-mp="2n2sn2ec12rf1" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}